import { ADMIN_CONFIG, SECURITY_CONFIG } from '@/config/admin.js'

// Security utilities for the backoffice
export class SecurityManager {
  static isAuthenticated() {
    const token = localStorage.getItem('admin_token')
    const authenticated = localStorage.getItem('admin_authenticated')
    const timestamp = localStorage.getItem('admin_timestamp')
    const sessionDuration = localStorage.getItem('admin_session_duration') || ADMIN_CONFIG.sessionDuration
    
    if (!token || !authenticated || !timestamp) return false
    
    const sessionAge = Date.now() - parseInt(timestamp)
    const maxAge = parseInt(sessionDuration)
    
    if (sessionAge > maxAge) {
      SecurityManager.clearSession()
      return false
    }
    
    return true
  }

  static clearSession() {
    localStorage.removeItem('admin_token')
    localStorage.removeItem('admin_authenticated')
    localStorage.removeItem('admin_timestamp')
    localStorage.removeItem('admin_session_duration')
    localStorage.removeItem('admin_info')
  }

  static getAuthHeaders() {
    const token = localStorage.getItem('admin_token')
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  }

  static logActivity(action, details = {}) {
    if (SECURITY_CONFIG.enableAuditLog) {
      const logEntry = {
        timestamp: new Date().toISOString(),
        action,
        details,
        userAgent: navigator.userAgent,
        url: window.location.href
      }
      console.log('Security Log:', logEntry)
    }
  }

  static validateSession() {
    if (!SecurityManager.isAuthenticated()) {
      SecurityManager.logActivity('session_expired')
      return false
    }
    return true
  }

  static checkRateLimit(action) {
    const key = `rate_limit_${action}`
    const attempts = parseInt(localStorage.getItem(key) || '0')
    const lastAttempt = parseInt(localStorage.getItem(`${key}_time`) || '0')
    
    const now = Date.now()
    const windowMs = 60000 // 1 minute window
    
    if (now - lastAttempt > windowMs) {
      // Reset counter if window has passed
      localStorage.setItem(key, '1')
      localStorage.setItem(`${key}_time`, now.toString())
      return true
    }
    
    if (attempts >= 10) { // Max 10 attempts per minute
      return false
    }
    
    localStorage.setItem(key, (attempts + 1).toString())
    return true
  }
}

// Export security functions
export const security = {
  isAuthenticated: SecurityManager.isAuthenticated,
  clearSession: SecurityManager.clearSession,
  logActivity: SecurityManager.logActivity,
  validateSession: SecurityManager.validateSession,
  checkRateLimit: SecurityManager.checkRateLimit
} 